<div>
  Your current balance is {{balance | number:'1.2'}}. You don't have enough funds in your account
  <div>
    <button mat-flat-button color="warn" (click)="proceed()">
      Proceed to Checkout
      <mat-icon>lock</mat-icon>
    </button>
  </div>
</div>
